import React from "react";
import { DEFAULT_PER_PAGE } from "../../../../helpers/default";
import ContentBlock from "../../../../components/Layout/ContentBlock";
import FilterMenu from "../../../../components/Layout/FilterMenu";
import {
  QueryClient,
  useMutation,
  useQuery,
  useQueryClient,
} from "react-query";
import Axios from "axios";
import {
  ButtonSecondary,
  Pagination,
  SelectInput,
  TextInput,
} from "../../../../components/globals";
import TableFilterBox from "../../../../components/common/TableFilterBox";
import {
  ButtonDelete,
  ButtonSmall,
  ButtonEditRow,
} from "../../../../components/common/Buttons";
import { IconSearch, IconHistory } from "../../../../components/Layout/Icons";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../../../helpers/AsyncMessage";
import TabUi from "../TabUi";
import SupplyIcon from "../../../../assets/icons/supply";
import { Checkbox, Modal } from "antd";
import { useModal } from "../../../../hooks";
import { AiOutlineLeft } from "react-icons/ai";
import { FaChevronDown } from "react-icons/fa";
import ModalNewSupplier from "./Modals/ModalNewSupplier";
import ModalImportSupplier from "./Modals/ModalImportSupplier";
import ModalNewProduct from "./Modals/ModalNewProduct";
import ModalBulkProduct from "./Modals/ModalBulkProduct";
import InputSwitchComponent from "../../../../components/common/InputSwitchComponent";
import ImportsHistory from "./Components/ImportsHistory";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { AiFillCaretDown } from "react-icons/ai";
import ContentValidation from "../../../../components/common/ContentValidation";
import DropdownButton from "./Components/DropdownButton";
import { useSelector } from "react-redux";

export const queryLostCartsClient = new QueryClient();

const { confirm } = Modal;

const SuppliersManagement = ({ tabId, setTabId, onSupplierNameChange }) => {
  const [totals, setTotals] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [perPage, setPerPage] = React.useState(DEFAULT_PER_PAGE);
  const [selectedSuppliers, setSelectedSuppliers] = React.useState([]);
  const [supplierCategory, setSupplierCategory] = React.useState("");
  const { modalOpt, setModalOpt, closeModal } = useModal();
  const [filterActive, setFilterActive] = React.useState(false);
  const [triggerFillter, setTriggerFillter] = React.useState(false);
  const [supplierId, setSupplierId] = React.useState(null);
  const [selectedSkus, setSelectedSkus] = React.useState([]);
  const [isVisible, setIsVisible] = React.useState(false);
  const [checkBoxDropdown, setCheckBoxDropdown] = React.useState(false);
  const [selectOptions, setSelectOptions] = React.useState([]);
  const [showHistory, setShowHistory] = React.useState(false);
  const [skuValue, setSkuValue] = React.useState("");
  const [supplierValue, setSupplierValue] = React.useState("");
  const [forceSaleValue, setForceSaleValue] = React.useState("");
  const [selectedSupplierName, setSelectedSupplierName] = React.useState("");
  const [isImporting, setIsImporting] = React.useState(null);
  const prevIsImportingRef = React.useRef();
  const dropdownRef = React.useRef(null);
  const queryClient = useQueryClient();
  const userRole = useSelector((state) => state.auth.user.user_role);
  console.log(selectedSkus, "selectedSkus");
  const fetchProductSuppliers = async () => {
    if (!supplierId) {
      throw new Error("No supplier ID");
    }

    let url = `/api/v1/suppliers/${supplierId}/product_suppliers/?page=${page}&per_page=${perPage}`;

    if (skuValue || supplierValue || forceSaleValue) {
      if (skuValue) url += `&q[product_identifier_cont]=${skuValue}`;
      if (supplierValue) url += `&q[code_cont]=${supplierValue}`;
      if (forceSaleValue) url += `&q[force_sale_eq]=${forceSaleValue}`;
    }

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  };

  const fetchSupplierImports = async () => {
    const { data } = await Axios.get("/api/v1/supplier_imports");
    return data;
  };

  const { data: supplierImports, refetch: supplierImportsRefetch } = useQuery(
    "supplierImports",
    fetchSupplierImports
  );

  React.useEffect(() => {
    const checkImports = async () => {
      const { data: updatedSupplierImports } = await supplierImportsRefetch();
      if (updatedSupplierImports && updatedSupplierImports?.data) {
        const isImporting = updatedSupplierImports?.data.some(
          (item) => !item.imported
        );
        setIsImporting(isImporting);
      }
    };

    checkImports();

    const intervalId = setInterval(checkImports, 3000);

    return () => clearInterval(intervalId);
  }, []);

  React.useEffect(() => {
    if (prevIsImportingRef.current && !isImporting) {
      antdAsyncMessageSuccess({
        key: "import",
        text: "Successfully imported suppliers",
      });
      refetchSuppliers();
    }
    prevIsImportingRef.current = isImporting;
  }, [isImporting]);

  const {
    data: customProducts,
    isLoading: productsLoading,
    error: errorProducts,
    refetch: refetchProducts,
  } = useQuery("productSuppliers", fetchProductSuppliers, {
    enabled: false,
  });

  const fetchSuppliers = async () => {
    let url = `/api/v1/suppliers/custom?page=${page}&per_page=${perPage}`;

    if (filterActive) {
      const supplierIds = selectedSuppliers;
      url += "&";
      supplierIds.forEach((id, index) => {
        if (index !== 0) url += "&";
        url += `q[id_in][]=${id}`;
      });
      if (supplierCategory) {
        url += `&q[title_cont]=${supplierCategory}`;
      }
    }
    const response = await fetch(url);
    const data = await response.json();
    return data;
  };

  const {
    data: customSuppliers,
    isLoading: suppliersLoading,
    error: errorSuppliers,
    refetch: refetchSuppliers,
  } = useQuery(["customSuppliers"], fetchSuppliers, {
    enabled: true,
  });

  const fetchProductSuppliersNoPaginator = async () => {
    if (!supplierId) {
      throw new Error("No supplier ID");
    }

    let url = `/api/v1/suppliers/${supplierId}/product_suppliers/?page=1&per_page=99999`;

    if (skuValue || supplierValue || forceSaleValue) {
      if (skuValue) url += `&q[product_identifier_cont]=${skuValue}`;
      if (supplierValue) url += `&q[code_cont]=${supplierValue}`;
      if (forceSaleValue) url += `&q[force_sale_eq]=${forceSaleValue}`;
    }

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  };

  const {
    data: customProductsNoPaginator,
    refetch: customProductsNoPaginatorRefetch,
    isLoading: productsNoPaginatorLoading,
  } = useQuery(
    "productSuppliersNoPaginator",
    fetchProductSuppliersNoPaginator,
    {
      enabled: true,
      onSuccess: (data) => {
        console.log(data, "data");
        if (data?.data) {
          setSelectedSkus(
            data.data.map((item) => ({
              id: item.id,
              sku: item.sku,
            }))
          );
        }
      },
    }
  );

  console.log(customProductsNoPaginator, "customProductsNoPaginator");

  const fetchAllDatamutation = useMutation(fetchProductSuppliersNoPaginator);

  React.useEffect(() => {
    fetchSuppliers();
    queryClient.invalidateQueries("suppliers");
  }, []);

  React.useEffect(() => {
    if (customProducts) {
      setTotals(customProducts?.totals);
    }
  }, [customProducts]);

  React.useEffect(() => {
    if (customSuppliers && !supplierId) {
      setTotals(customSuppliers?.totals);
    }
  }, [customSuppliers, supplierId]);

  React.useEffect(() => {
    if (supplierId) {
      refetchProducts();
    } else {
      refetchSuppliers();
    }
  }, [page, perPage]);

  const handleFilterChange = () => {
    setTriggerFillter((prevFilterActive) => !prevFilterActive);
    setFilterActive(true);
  };

  React.useEffect(() => {
    if (supplierId) {
      refetchProducts();
    } else {
      refetchSuppliers();
    }
  }, [triggerFillter]);

  const mutationSuppliersRemove = useMutation({
    mutationFn: ({ id }) => {
      antdAsyncMessageLoading({
        key: `remove_custom_suppliers`,
        message: "Deleting Supplier",
      });
      return Axios.delete(`/api/v1/suppliers/${id}`);
    },
    onSuccess: (data) => {
      refetchSuppliers();
      antdAsyncMessageSuccess({
        key: "remove_custom_suppliers",
        message: "Successfully removed",
      });
    },
    onError: (error) => {
      antdAsyncMessageError({
        key: "remove_custom_suppliers",
        message: error.response.data.message,
      });
    },
  });

  const mutationProductsRemove = useMutation({
    mutationFn: ({ id }) => {
      antdAsyncMessageLoading({
        key: `remove_product_suppliers`,
        message: "Deleting Product",
      });
      return Axios.delete(`/api/v1/product_suppliers/${id}`);
    },
    onSuccess: (data) => {
      refetchProducts();
      antdAsyncMessageSuccess({
        key: "remove_product_suppliers",
        message: "Successfully removed",
      });
    },
    onError: (error) => {
      antdAsyncMessageError({
        key: "remove_product_suppliers",
        message: error.response.data.message,
      });
    },
  });

  const mutationBulkProductsRemove = useMutation({
    mutationFn: ({ ids }) => {
      antdAsyncMessageLoading({
        key: `bulk_remove_product_suppliers`,
        message: "Deleting Products",
      });
      return Axios.post(`/api/v1/product_suppliers/bulk_destroy`, {
        product_supplier_ids: ids,
      });
    },
    onSuccess: () => {
      refetchProducts();
      setSelectedSkus([]);
      antdAsyncMessageSuccess({
        key: "bulk_remove_product_suppliers",
        message: "Successfully removed",
      });
    },
    onError: (error) => {
      antdAsyncMessageError({
        key: "bulk_remove_product_suppliers",
        message: error?.response?.data?.message || "Error deleting products",
      });
    },
  });

  const onFilterClear = () => {
    setFilterActive(false);
    setSelectedSuppliers([]);
    setSupplierCategory("");
    refetchSuppliers();
    setSkuValue("");
    setSupplierValue("");
    setForceSaleValue("");
    if (supplierId) {
      refetchProducts();
    }
  };

  React.useEffect(() => {
    refetchSuppliers();
    if (supplierId) {
      refetchProducts();
    }
  }, [modalOpt, supplierId]);

  const handleButtonClick = (id) => {
    setSupplierId(id);
    const supplier = customSuppliers.data.find(
      (supplier) => supplier.id === id
    );
    if (supplier) {
      setSelectedSupplierName(supplier.name);
    }
  };

  React.useEffect(() => {
    if (selectedSupplierName) {
      onSupplierNameChange(selectedSupplierName);
    }
    if (selectedSupplierName === "") onSupplierNameChange(selectedSupplierName);
  }, [selectedSupplierName]);

  React.useEffect(() => {
    if (supplierId) {
      refetchProducts();
    }
  }, [supplierId]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedSkus(
        customProducts?.data?.map((item) => ({ id: item.id, sku: item.sku })) ||
        []
      );
    } else {
      setSelectedSkus([]);
    }
  };

  const handleSelectSku = (id, sku, e) => {
    if (e.target.checked) {
      setSelectedSkus((prevSelectedSkus) => [...prevSelectedSkus, { id, sku }]);
    } else {
      setSelectedSkus((prevSelectedSkus) =>
        prevSelectedSkus.filter((selectedItem) => selectedItem.id !== id)
      );
    }
  };

  const hanldeAllSkus = () => {
    customProductsNoPaginatorRefetch();
    // fetchAllDatamutation.mutate();
    // if (customProductsNoPaginator?.data) {
    //   setSelectedSkus(
    //     customProductsNoPaginator.data.map((item) => ({
    //       id: item.id,
    //       sku: item.sku,
    //     }))
    //   );
    // }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setCheckBoxDropdown(false);
    }
  };

  React.useEffect(() => {
    const fetchSelectOptions = async () => {
      const response = await fetch("/api/v1/suppliers/custom");
      const data = await response.json();
      setSelectOptions(
        data.data.map((supplier) => ({
          value: supplier.id,
          label: supplier.name,
        }))
      );
    };

    fetchSelectOptions();
  }, []);

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <ContentBlock>
        <FilterMenu
          length={
            supplierId
              ? customProducts?.data?.length
              : customSuppliers?.data?.length
          }
          text2={`Total ${supplierId ? "products " : "suppliers"}`}
          iconComponent={supplierId ? null : <SupplyIcon />}
          onChangeCountPage={setPerPage}
          countPage={perPage}
          totals={totals}
          page={page}
        />
      </ContentBlock>
      <div className="col-12">
        {supplierId ? (
          <div
            className="d-flex flex-row align-items-center mt-3 mb-3 cursor-pointer"
            onClick={() => {
              setSupplierId(null);
              setSelectedSupplierName("");
              setSelectedSkus([]);
              setPage(1);
              setPerPage(DEFAULT_PER_PAGE);
            }}
          >
            <AiOutlineLeft color="#CACACA" />
            <p style={{ marginBottom: 0, marginTop: 0, marginLeft: 2 }}>
              Return to suppliers list
            </p>
          </div>
        ) : (
          <TabUi tabId={tabId} setTabId={setTabId} />
        )}
      </div>
      <ContentBlock containerClass={"py-1"} style={{ marginBottom: "1rem" }}>
        <TableFilterBox
          filter={true}
          onFilter={() => {
            handleFilterChange();
          }}
          add={false}
          clearFilter={() => onFilterClear()}
          button1={
            <>
              {supplierId ? (
                <>
                  <div className="float-left ml-2" style={{ width: 104 }}>
                    <ButtonSecondary
                      onClick={() => setModalOpt("new_product", supplierId)}
                    >
                      Add SKU
                    </ButtonSecondary>
                  </div>
                  <div
                    className="float-left ml-2"
                    style={{ width: 100, position: "relative" }}
                  >
                    <DropdownButton
                      buttonText="Bulk action"
                      buttonId="bulk-action"
                      style={{
                        width: 104,
                        height: 29,
                        lineHeight: "19px",
                        backgroundColor: "#007bff",
                        fontWeight: "600",
                        padding: "5px 10px",
                        fontSize: 12,
                        boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                      }}
                      child={
                        <div>
                          <div
                            onClick={() => {
                              if (selectedSkus?.length > 0) {
                                setModalOpt("bulk_whole_price_product", 1);
                                setIsVisible(false);
                              }
                            }}
                            className="bulk-action-dropbox"
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            <p
                              style={{
                                fontSize: 12,
                                color: "#2B2A29",
                                paddingLeft: 8,
                                paddingRight: 8,
                                paddingTop: 8,
                                paddingBottom: 8,
                                marginBottom: 0,
                              }}
                            >
                              Change whole price {selectedSkus?.length}
                            </p>
                          </div>
                          <div
                            onClick={() => {
                              if (selectedSkus?.length > 0) {
                                setModalOpt("bulk_quantity_product", 1);
                                setIsVisible(false);
                              }
                            }}
                            className="bulk-action-dropbox"
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            <p
                              style={{
                                fontSize: 12,
                                paddingTop: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                paddingRight: 8,
                                marginBottom: 0,
                                color: "#2B2A29",
                              }}
                            >
                              Change quantity {selectedSkus?.length}
                            </p>
                          </div>
                          <div
                            onClick={() => {
                              if (selectedSkus?.length > 0) {
                                confirm({
                                  title: `Are you sure you want to delete ${selectedSkus.length} product(s)?`,
                                  icon: (
                                    <ExclamationCircleOutlined className="text-danger" />
                                  ),
                                  content:
                                    "You will not be able to undo this action",
                                  okType: "danger",
                                  onOk: () => {
                                    mutationBulkProductsRemove.mutate({
                                      ids: selectedSkus.map((item) => item.id),
                                    });
                                  },
                                });
                                setIsVisible(false);
                              }
                            }}
                            className="bulk-action-dropbox"
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            <p
                              style={{
                                fontSize: 12,
                                paddingTop: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                paddingRight: 8,
                                marginBottom: 0,
                                color: "#dc3545",
                              }}
                            >
                              Delete selected {selectedSkus?.length}
                            </p>
                          </div>
                        </div>
                      }
                    />
                  </div>
                </>
              ) : (
                <>
                  {userRole.title === "Super Admin" && (
                    <div className="float-left ml-2" style={{ width: 104 }}>
                      <ButtonSecondary
                        onClick={() => setModalOpt("new_supplier", 1)}
                      >
                        New supplier
                      </ButtonSecondary>
                    </div>
                  )}
                  <div
                    className="float-left ml-2"
                    style={{ width: 140, position: "relative" }}
                  >
                    <ButtonSecondary
                      className="import-suppliers-button"
                      onClick={() => setModalOpt("import_supplier", 1)}
                      buttonLoader={isImporting}
                    >
                      Import suppliers
                    </ButtonSecondary>
                    <div
                      onClick={() => setShowHistory((prev) => !prev)}
                      className="import-suppliers-button-icon"
                    >
                      <IconHistory />
                    </div>
                    {showHistory && (
                      <ImportsHistory setShowHistory={setShowHistory} />
                    )}
                  </div>
                </>
              )}
            </>
          }
        >
          <div className="d-flex justify-content-between flex-1 flex-wrap">
            <div className="d-flex flex-wrap">
              {supplierId ? (
                <>
                  <div className="px-1">
                    <TextInput
                      text="SKU"
                      name="SKU"
                      style={{ width: 165 }}
                      value={skuValue}
                      onChange={(val) => {
                        setSkuValue(val.target.value);
                      }}
                    />
                  </div>
                  <div className="px-1">
                    <TextInput
                      text="Supplier code"
                      name="Supplier code"
                      style={{ width: 165 }}
                      value={supplierValue}
                      onChange={(val) => {
                        setSupplierValue(val.target.value);
                      }}
                    />
                  </div>
                  <div className="px-1">
                    <InputSwitchComponent
                      label="Force sale"
                      name="auto_type"
                      options={[
                        {
                          label: "All",
                          value: "",
                        },
                        {
                          label: "Yes",
                          value: "true",
                        },
                        {
                          label: "No",
                          value: "false",
                        },
                      ]}
                      value={forceSaleValue}
                      onChange={(val) => {
                        setForceSaleValue(val.target.value);
                      }}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="px-1">
                    <SelectInput
                      mode="multiple"
                      label="Supplier"
                      name="Supplier"
                      className="w-100"
                      style={{ width: 200 }}
                      options={selectOptions}
                      value={selectedSuppliers}
                      onChange={(val) => {
                        console.log(val);
                        setSelectedSuppliers(val);
                      }}
                    />
                  </div>
                  <div className="px-1">
                    <TextInput
                      text="Supplier title"
                      name="Supplier"
                      style={{ width: 165 }}
                      value={supplierCategory}
                      onChange={(val) => {
                        setSupplierCategory(val.target.value);
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </TableFilterBox>
        <div>
          <div className="table-responsive" style={{ overflow: "hidden" }}>
            <ContentValidation
              loader={supplierId ? productsLoading : suppliersLoading}
              array={supplierId ? customProducts?.data : customSuppliers?.data}
              error={supplierId ? errorProducts : errorSuppliers}
            >
              {supplierId ? (
                <table className="table mt-3">
                  <thead>
                    <tr className="text-muted">
                      <th className="text-black">
                        <div className="d-flex flex-row align-items-center">
                          <Checkbox
                            onChange={handleSelectAll}
                            checked={
                              selectedSkus.length ===
                              customProducts?.data?.length ||
                              selectedSkus.length > customProducts?.data?.length
                            }
                          />
                          <div
                            className="suppliers-management-dropdown"
                            ref={dropdownRef}
                          >
                            <AiFillCaretDown
                              onClick={() =>
                                setCheckBoxDropdown(!checkBoxDropdown)
                              }
                              className="cursor-pointer"
                            />
                            {checkBoxDropdown && (
                              <div className="suppliers-management-dropdown-content">
                                {productsNoPaginatorLoading ? (
                                  <div className="d-flex p-2">
                                    <span className="spinner-border spinner-border-sm"></span>
                                  </div>
                                ) : (
                                  <>
                                    <div
                                      className="suppliers-management-dropdown-item"
                                      onClick={() => hanldeAllSkus()}
                                    >
                                      <p>Select all {customProducts?.totals}</p>
                                    </div>
                                    <div
                                      className="suppliers-management-dropdown-item"
                                      onClick={() =>
                                        handleSelectAll({
                                          target: { checked: true },
                                        })
                                      }
                                    >
                                      <p>
                                        Select all in page{" "}
                                        {customProducts?.data?.length}
                                      </p>
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                          SKU
                        </div>
                      </th>
                      <th className="text-black">Supplier code</th>
                      <th className="text-black">Supplier category</th>
                      <th className="text-black">Wholesale price</th>
                      <th className="text-black">Quantity</th>
                      <th className="text-black">Force sale</th>
                      <th className="text-black"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {customProducts?.data?.map?.((item) => (
                      <tr className="align-middle tableColumn" key={item.id}>
                        <td className="align-middle">
                          <div className="d-flex">
                            <Checkbox
                              style={{ marginRight: 10 }}
                              onChange={(e) =>
                                handleSelectSku(item.id, item.sku, e)
                              }
                              checked={selectedSkus.some(
                                (selectedItem) => selectedItem.id === item.id
                              )}
                            />
                            {item.sku}
                          </div>
                        </td>
                        <td className="align-middle">{item.code}</td>
                        <td className="align-middle">{item?.category}</td>
                        <td className="align-middle">{item.wholesale_price}</td>
                        <td className="align-middle">{item.quantity}</td>
                        <td className="align-middle">
                          {item.force_sale ? "Yes" : "No"}
                        </td>
                        <td className="align-middle">
                          <div
                            className="d-flex justify-content-end"
                            style={{ gap: 5 }}
                          >
                            <ButtonEditRow
                              className="d-flex justify-content-center align-items-center"
                              onClick={() =>
                                setModalOpt("edit_product", item.id)
                              }
                            />
                            <ButtonDelete
                              className="d-flex justify-content-center align-items-center"
                              onDelete={() =>
                                confirm({
                                  title: "Are you sure?",
                                  icon: (
                                    <ExclamationCircleOutlined className="text-primary" />
                                  ),
                                  content:
                                    "You will not be able to undo this action",
                                  onOk: () => {
                                    mutationProductsRemove.mutate({
                                      id: item.id,
                                    });
                                  },
                                  onCancel() {
                                    console.log("Cancel");
                                  },
                                })
                              }
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <table className="table mt-3">
                  <thead>
                    <tr className="text-muted">
                      <th className="text-black">Supplier</th>
                      <th className="text-black">Supplier title</th>
                      <th className="text-black">SKU quantity</th>
                      <th className="text-black">Delivery time</th>
                      <th className="text-black"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {customSuppliers?.data?.map?.((item) => (
                      <tr className="align-middle tableColumn" key={item.id}>
                        <td className="align-middle">{item?.name}</td>
                        <td className="align-middle">{item?.title}</td>
                        <td className="align-middle">{item?.total_products}</td>
                        <td className="align-middle">{item?.delivery_time}</td>
                        <td className="align-middle">
                          <div
                            className="d-flex justify-content-end"
                            style={{ gap: 5 }}
                          >
                            <ButtonSmall
                              className="d-flex justify-content-center align-items-center"
                              onClick={() => handleButtonClick(item.id)}
                            >
                              <IconSearch color="#fff" />
                            </ButtonSmall>
                            {userRole.title === "Super Admin" && (
                              <ButtonEditRow
                                className="d-flex justify-content-center align-items-center"
                                onClick={() =>
                                  setModalOpt("edit_supplier", item.id)
                                }
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </ContentValidation>
            <Pagination
              setPagination={setPage}
              page={page}
              totals={totals}
              pageCount={perPage}
            />
          </div>
        </div>
      </ContentBlock>
      {["new_supplier", "edit_supplier"].includes(modalOpt?.type) && (
        <ModalNewSupplier
          modalOpt={modalOpt}
          onClose={closeModal}
          customSuppliers={customSuppliers}
        />
      )}
      {["new_product", "edit_product"].includes(modalOpt?.type) && (
        <ModalNewProduct
          modalOpt={modalOpt}
          onClose={closeModal}
          refetchProducts={refetchProducts}
          customSuppliers={customSuppliers}
          customProducts={customProducts}
          supplierId={supplierId}
        />
      )}
      {["bulk_quantity_product", "bulk_whole_price_product"].includes(
        modalOpt?.type
      ) && (
          <ModalBulkProduct
            modalOpt={modalOpt}
            onClose={closeModal}
            selectedSkus={selectedSkus}
          />
        )}

      {modalOpt?.type == "import_supplier" && (
        <ModalImportSupplier modalOpt={modalOpt} onClose={closeModal} />
      )}
    </>
  );
};

export default SuppliersManagement;
